module.exports = __webpack_public_path__ + "img/qyry.657dc5a6.jpg";